import { deleteAdminAccountList } from './deleteAdminAccountList';
import { saveAdminAccount } from './saveAdminAccount';

// actionName と function のマッピング
export const tenantAdminCallMap = {
  deleteAdminAccountList: deleteAdminAccountList,
  saveAdminAccount: saveAdminAccount,
};
